/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Workflow_StartedInputs */

const cs_toast_workflow_started = /** @type {(inputs: Toast_Workflow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow spuštěno`)
};

const en_toast_workflow_started = /** @type {(inputs: Toast_Workflow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow started`)
};

/**
* | output |
* | --- |
* | "Workflow started" |
*
* @param {Toast_Workflow_StartedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const toast_workflow_started = /** @type {((inputs?: Toast_Workflow_StartedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Workflow_StartedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_workflow_started(inputs)
	return cs_toast_workflow_started(inputs)
});